export const relativeRemoteWidgetUrl = (widget) => '/remote-widget/' + widget;
